import { motion } from "framer-motion";
import { Send } from "lucide-react";
import OwlLogo from "./OwlLogo";

export const PhoneMockup = ({ companionName = "Chouette", welcomeMessage = "Bonjour !" }) => (
  <div className="relative mx-auto w-[280px] sm:w-[310px]" data-testid="phone-mockup">
    <div className="rounded-[2.8rem] bg-ink p-2 shadow-2xl shadow-ink/25">
      <div className="rounded-[2.3rem] bg-paper overflow-hidden">
        <div className="h-7 flex items-center justify-center">
          <div className="h-1.5 w-16 rounded-full bg-ink/15" />
        </div>
        <div className="px-4 py-3 flex items-center gap-2.5 bg-paper2/70 border-b border-ink/5">
          <div className="w-9 h-9 rounded-full bg-white ring-2 ring-mint flex items-center justify-center shrink-0">
            <OwlLogo variant="face" className="w-6 h-6" />
          </div>
          <div>
            <p className="text-xs font-bold leading-tight" data-testid="phone-companion-name">{companionName}</p>
            <p className="text-[10px] text-emerald-600 flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" /> en ligne
            </p>
          </div>
        </div>
        <div className="p-4 space-y-3 text-[12.5px] leading-snug h-[380px] overflow-hidden">
          <div className="max-w-[85%] rounded-2xl rounded-tl-md bg-hi text-ink px-3.5 py-2.5">{welcomeMessage}</div>
          <div className="max-w-[85%] ml-auto rounded-2xl rounded-tr-md bg-coral text-ink px-3.5 py-2.5">
            Chouette, c'est quoi un complément à 10 ?
          </div>
          <div className="max-w-[85%] rounded-2xl rounded-tl-md bg-hi text-ink px-3.5 py-2.5">
            Super question ! Si tu as 7, combien manque-t-il pour arriver à 10 ? Compte sur tes doigts, je t'aide si tu bloques.
          </div>
          <div className="max-w-[85%] ml-auto rounded-2xl rounded-tr-md bg-coral text-ink px-3.5 py-2.5">3 ! 7 + 3 = 10</div>
          <div className="max-w-[85%] rounded-2xl rounded-tl-md bg-mint text-ink px-3.5 py-2.5 flex items-center gap-1.5">
            Exactement, bravo !
            <motion.span
              className="inline-block w-1.5 h-1.5 rounded-full bg-ink/50"
              animate={{ opacity: [0.2, 1, 0.2] }}
              transition={{ duration: 1.2, repeat: Infinity }}
            />
          </div>
        </div>
        <div className="px-4 pb-5">
          <div className="flex items-center gap-2 rounded-full border border-ink/10 bg-white px-4 py-2.5 text-xs text-ink/40">
            Écris ta question…
            <Send className="w-3.5 h-3.5 ml-auto text-coral" />
          </div>
        </div>
      </div>
    </div>
    <motion.span
      className="absolute -right-4 sm:-right-8 top-16 rotate-3 rounded-full bg-hi text-ink text-xs font-bold px-3.5 py-1.5 shadow-lg"
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
    >
      Devoir terminé ✓
    </motion.span>
    <motion.span
      className="absolute -left-4 sm:-left-10 bottom-28 -rotate-3 rounded-full bg-coral text-ink text-xs font-bold px-3.5 py-1.5 shadow-lg"
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      Bien joué !
    </motion.span>
  </div>
);

export default PhoneMockup;